import { render, staticRenderFns } from "./SortHeader.vue?vue&type=template&id=94dd4954&"
import script from "./SortHeader.vue?vue&type=script&lang=ts&"
export * from "./SortHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SortHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports